/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import Meta from 'vue-meta'
import {authService} from '../services/ServiceInst.js'
import store from '@/store'

// Routes
import paths from './paths'

function route (path, view, name, props) {
  return {
    name: name || view,
    props: props || false,
    path,
    component: (resovle) => import(
      `@/views/${view}.vue`
    ).then(resovle)
  }
}

Vue.use(Router)

// Create a new router
const router = new Router({
  // mode: 'history',
  routes: paths.map(path => route(path.path, path.view, path.name, path.props)).concat([
    { path: '*', redirect: '/timesheets' }
  ]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

/**
 * Before navigating to a route perfom some checks
 */
router.beforeEach((to, from, next) => {
  if ((to.name.includes('Admin') || to.name.includes('Reports') || to.name.includes('ViewSubmissions')) && !store.state.app.userProfile.IsAdmin) {
    next({
      path: '/timesheets'
    })
  } else if( from.name == null && authService.isAuthenticated() && to.name == "Login") {
    next({
      path: '/timesheets'
    })
  } else if(authService.isAuthenticated() || to.name == "Login" ) {
    // This is so that application doesn't redirect me straight away once logged in
    next(true)
  } else {
    if(to.name == 'Approval') {
      // store.state.admin.approvalObject = to
      // console.log(to)
      Vue.approvals.set('approvalObject', JSON.stringify(to))
    }
    next({
      path: '/'
    })
  }
})

// =============================================
// NOTE: vue-meta and Analytics can be removed |
// =============================================
Vue.use(Meta)

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== 'development'
    }
  })
}

export default router
